import { render } from "./ChartArea.vue?vue&type=template&id=7b87870c&scoped=true"
import script from "./ChartArea.vue?vue&type=script&lang=js"
export * from "./ChartArea.vue?vue&type=script&lang=js"

import "./ChartArea.vue?vue&type=style&index=0&id=7b87870c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b87870c"]])

export default __exports__